export default {
  SettingBaseDataLovHeader: {
    name: 'Name',
    code: 'Code',
    confirmText: 'Whether To Continue?',
    sourceText: 'No permission to operate on predefined data',
    table: {
      name: 'Name',
      code: 'Code',
      source: 'source',
      basicInformation: 'Account Information',
      add: 'Create Value Set',
      edit: 'Edit Value Set',
      nameText: 'Please enter value set name',
      codeText: 'Please enter value set code',
    }
  }
};
